import DOMPurify from 'dompurify';

// Using dangerouslySetInnerHTML in React can be dangerous because it allows you to inject HTML directly into the DOM, bypassing React's usual safeguards.
// This can expose your application to several security risks, the most notable being Cross-Site Scripting (XSS) attacks.
export const getSanitizedHtmlMsg = (htmlMsg: string) => {
  return DOMPurify.sanitize(htmlMsg);
};
